import { render, staticRenderFns } from "./product-detail-info.vue?vue&type=template&id=4770ed89&scoped=true&"
import script from "./product-detail-info.vue?vue&type=script&lang=js&"
export * from "./product-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./product-detail-info.vue?vue&type=style&index=0&id=4770ed89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770ed89",
  null
  
)

export default component.exports